<template>  
  <VUEModal :Titolo="Titolo" 
            :Programma="''" 
            :Altezza="AltezzaPopup" 
            :Larghezza="'900px'" 
            :PathLogo="require('@/assets/images/LogoDMS.png')"
            @onClickChiudiModal="OnClickChiudiModal"
            @OnClickConfermaModal="OnClickConfermaModal">

    <template v-slot:Body>
      
      <div style="margin-bottom: 40px; width: 100%;">
        <div class="form-control ZMPopupSelectionTab" style="width:50%;" :style="TabSelezionato == Tabs.Configurazione ? {'background-color' : Arancione, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Configurazione">{{Tabs.Configurazione}}</div>
        <div class="form-control ZMPopupSelectionTab" style="width:50%;" :style="TabSelezionato == Tabs.Grafici     ? {'background-color' : Arancione, 'color' : 'white'} : {}" @click="TabSelezionato = Tabs.Grafici">{{Tabs.Grafici}}</div>
      </div>

      <div v-if="TabSelezionato == Tabs.Configurazione">

        <div class="ZMNuovaRigaScheda" style="display:flex">
          <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 1%; margin-top: 3%;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input :placeholder="this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(30%)" v-model="NomeBanda">
            
          </div>
        </div>

        <div class="col-md-12" v-if="NomeBanda == ''">
          <div style="float:left;width:3%;">&nbsp;</div>
          <label style="font-size:12px;margin-left: 16%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('Generic','TKN_ERR_NOME',this.LinguaUtente) }}</label>
        </div>
        
        <div class="ZMNuovaRigaScheda" style="display:flex">
          <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 1%;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('Generic','TKN_ALTEZZA',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input :placeholder="this.GetTraduzioneLabel('Generic','TKN_ALTEZZA',this.LinguaUtente)" class="form-control" type="text" style="float: left; width: calc(30%)" v-model="AltezzaBanda">
          </div>
        </div>

        <div class="col-md-12" v-if="AltezzaBanda == ''">
          <div style="float:left;width:3%;">&nbsp;</div>
          <label style="font-size:12px;margin-left: 16%;" class="ZMFormLabelError">{{ this.GetTraduzioneLabel('Generic','TKN_ERR_ALTEZZA',this.LinguaUtente) }}</label>
        </div>

        <div class="ZMNuovaRigaScheda" style="display:flex">
          <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 1%;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupModificaBanda','TKN_COL_BANDA',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <div class="ZMColorPickerDiv" :style="{'background-color' : ColoreBanda, 'width' : '30%', 'float' : 'left'}" @click="ApriPopupColorPicker()">&nbsp;</div>
          </div>
        </div>

        <div class="ZMNuovaRigaScheda" style="display:flex">
          <div class="ZMDivPopupContent" style="width: 100%; margin-bottom: 1%;">
            <label class="ZMLabelDescriptionPopup" style="margin-bottom: 0px;">{{ this.GetTraduzioneLabel('VUEPopupModificaBanda','TKN_BANDA_NASCOSTA',this.LinguaUtente) }}</label>
            <div style="width:20px;float:left">&nbsp;</div> 
            <input class="form-control" type="checkbox" style="float: left; width:2%" v-model="BandaNascosta">
          </div>
        </div>

      </div>

      <div v-if="TabSelezionato == Tabs.Grafici">    

        
        <div style="display:flex; margin-bottom: 2%; justify-content: flex-end">
          <button @click="OnClickAggiungiElemento" type="button" class="btn btn-success" style="width:20%">{{ this.GetTraduzioneLabel('Generic','TKN_AGGIUNGI',this.LinguaUtente) }}</button>
        </div>

        <table cellpadding="0" cellspacing="0" width="100%" class="table table-bordered table-striped sortable">
          <thead style="background-color:#60604d;color:white">
            <tr>
              <th width="30%">{{ this.GetTraduzioneLabel('Generic','TKN_NOME',this.LinguaUtente) }}</th>
              <th width="22%">{{ this.GetTraduzioneLabel('Generic','TKN_LARGHEZZA',this.LinguaUtente) }}</th>                               
              <th width="35%">{{ this.GetTraduzioneLabel('Generic','TNK_TIPO',this.LinguaUtente) }}</th>                               
              <th width="13%">{{ this.GetTraduzioneLabel('VUEAppContentGestioneUtenti','TKN_APP_CON_GEST_UTENTE_AZIONI',this.LinguaUtente) }}</th>
            </tr>
          </thead>
          <tbody :style="{'background-color' : Arancione}">
            <tr v-for="(Elemento, chiave) in JSONCurrentBanda.MODULO_GRAFICO" :key="chiave">
              <td style="vertical-align:middle">{{ Elemento.NOME_ELEMENTO }}</td>
              <td style="vertical-align:middle">{{ Elemento.LARGHEZZA }}</td>                         
              <td style="vertical-align:middle">{{ GetTipoDescr(Elemento.ELEMENTO) }}</td>                         
              <td style="vertical-align:middle;text-align:center;">
                <i class="fa fa-pencil text-warning ZMIconButton" @click="OnClickApriGrafico(Elemento, chiave)" style="margin-right:10px"></i>
                <i class="fa fa-trash-o text-danger ZMIconButton" @click="OnClickEliminaCurrentGrafico(chiave)" style="margin-right:10px"></i>
                <i v-if="chiave !== 0" class="fa fa-arrow-up ZMIconButton" @click="OnClickSpostaInAlto(chiave)" style="margin-right:4px"></i>
                <i v-if="chiave === 0" class="fa fa-trash-o" style="margin-right:4px; opacity: 0;"></i>
                <i v-if="chiave !== JSONCurrentBanda.MODULO_GRAFICO.length - 1" class="fa fa-arrow-down ZMIconButton" @click="OnClickSpostaInBasso(chiave)"></i>
                <i v-if="chiave === JSONCurrentBanda.MODULO_GRAFICO.length - 1" class="fa fa-trash-o" style="opacity: 0;"></i>
              </td>
            </tr>
          </tbody>
        </table>

      </div>

      <VUEPopupModificaGraficoBanda v-if="PopupModificaGrafico" 
                                :Titolo="this.GetTraduzioneLabel('Generic','TKN_DMS_EW',this.LinguaUtente) + ' [' + this.GetTraduzioneLabel('VUEPopupModulazioneGrafici','TKN_MOD_GRAFICI',this.LinguaUtente) + ']'" 
                                :AltezzaPopup="AltezzaPopup" 
                                :ObjGrafici="GraficoSelezionato"
                                :VettoreModuli="VettoreModuli"
                                :IsEstensimetroPresente="IsEstensimetroPresente"
                                @OnClickConfermaPopup="OnClickConfermaPopupModificaGrafico"
                                @OnClickChiudiPopup="OnClickChiudiPopupModificaGrafico"/>
    </template>
   
    <template  v-slot:Footer>
      <button type="button" class="btn btn-danger" style="float:right;margin-left:10px;font-weight:bold;width:20%" @click="OnClickChiudiModal" data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_ANNULLA',this.LinguaUtente) }}</button>
      <button v-if="CanRecord()" type="button" class="btn btn-success" style="float:right;font-weight:bold;width:20%" @click="OnClickConfermaModal"  data-dismiss="modal">{{ this.GetTraduzioneLabel('Generic','TKN_CONFERMA',this.LinguaUtente) }}</button>
    </template>
 
  </VUEModal>

  <VUEColorPicker :Popup="PopupColorPicker" Programma="DMSEW" :Colore="ColoreInModifica" @OnClickConfermaPopup="ConfermaColore()" @OnClickChiudiPopup="AnnullaColore()"></VUEColorPicker>

</template>

<script>  

import VUEModal from '@/utils/VUEModal.vue';            
import { SystemInformation, TIPI_MODULI, COLORI_PANTONE } from '@/SystemInformation'
import VUEColorPicker from '@/utils/VUEColorPicker.vue'
import VUEPopupModificaGraficoBanda from '../../components/Popups/VUEPopupModificaGraficoBanda.vue';
import { TZGenericFunct } from '@/utils/ZGenericFunct.js'
import MixInsGestioneTraduzioni from '@/utils/MixInsGestioneTraduzioni.js';
import { TMontaggioGV } from '../../components/Slots/VUEComponenteGraficoGV.vue';

export default 
{
  data()
  {
   return {
            LinguaUtente          : SystemInformation.UserInformation.Lingua,
            JSONCurrentBanda      : {},
            Moduli                : TIPI_MODULI,
            AltezzaBanda          : -1,
            BandaNascosta         : false,
            ColoreBanda           : '',
            GraficoSelezionato    : '',
            PopupColorPicker      : false,
            PopupModificaGrafico  : false,
            IsNuovoElemento       : false,
            ColoreInModifica      : {},
            IndexGraficoAperto    : -1,
            NomeBanda             : '',
            Arancione             : COLORI_PANTONE.Arancione,
            Tabs                  : { 
                                      Configurazione : this.GetTraduzioneLabel('Generic','TKN_CONFIGURAZIONE', SystemInformation.UserInformation.Lingua),
                                      Grafici        : this.GetTraduzioneLabel('Generic','TKN_GRAFICI', SystemInformation.UserInformation.Lingua)
                                    },            
            TabSelezionato        : this.GetTraduzioneLabel('Generic','TKN_CONFIGURAZIONE', SystemInformation.UserInformation.Lingua),
          }
  },

  props : ['AltezzaPopup', 'Titolo', 'ObjBanda', 'VettoreModuli', 'IsEstensimetroPresente'],
  emits : ['OnClickChiudiPopup', 'OnClickConfermaPopup'],
  mixins: [MixInsGestioneTraduzioni],
  components: { 
                VUEModal,
                VUEColorPicker,
                VUEPopupModificaGraficoBanda
              },

  methods :
  {
    OnClickChiudiModal()
    {
      this.$emit('OnClickChiudiPopup')
    },

    OnClickConfermaModal()
    {
      this.$emit('OnClickConfermaPopup', this.JSONCurrentBanda)
    },

    OnClickAggiungiElemento()
    {
      this.JSONCurrentBanda.MODULO_GRAFICO.push({ 
                                                  ELEMENTO                   : '',
                                                  NOME_ELEMENTO              : '',
                                                  LARGHEZZA                  : '',
                                                  IMMAGINE                   : '',
                                                  LUNGHEZZA_TEMPORALE_GIORNI : '',
                                                  LUNGHEZZA_TEMPORALE_ORE    : '',
                                                  ORIENTAMENTO               : '0',
                                                  MODULI                     : '',
                                                  IS_GIORNALIERO             : true,
                                                  MOSTRA_PITCH               : true,
                                                  MOSTRA_ROLL                : true,
                                                  MOSTRA_TEMP                : true,
                                                  MOSTRA_PIEZO               : false,
                                                  MOSTRA_EST                 : false,
                                                  MOSTRA_MARKUP              : false,
                                                  MOSTRA_TOTALE              : false,
                                                  COLORE_PITCH               : 'purple',
                                                  COLORE_ROLL                : 'green',
                                                  COLORE_TEMP                : 'red',
                                                  COLORE_PIEZO               : 'blue',
                                                  COLORE_EST                 : 'brown',
                                                  COLORE_TOTALE              : TZGenericFunct.GenerateRandomColor(['#FFFFFF, #ffffff']),
                                                  CONFIGURAZIONE_GRAFICO_GV  : new TMontaggioGV(),
                                                })
      this.GraficoSelezionato   = this.JSONCurrentBanda.MODULO_GRAFICO[(this.JSONCurrentBanda.MODULO_GRAFICO.length -1)]
      this.IndexGraficoAperto   = this.JSONCurrentBanda.MODULO_GRAFICO.length -1
      this.IsNuovoElemento      = true
      this.PopupModificaGrafico = true 
    },

    GetTipoDescr(Modulo)
    {
        let Result = ''
        switch(Modulo)
        {
          case (this.Moduli.Polare)         : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_POLARE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostEst)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_E',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostNord)      : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_N',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostTot)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_S_T',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.SpostAzimuth)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_AZIMUTH',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Temperatura)    : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_TEMPERATURA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Deformazione)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_TITOLO_DEF',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Piezometro)     : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_PIEZOMETRO',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Spacer)         : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_SPACER',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.InfoGenerali)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_INFO_GEN',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Abbinati)       : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_GRAF_ABB',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Allineamento)   : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_RIALL_DATA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Immagine)       : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_IMMAGINE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.CampRilevati)   : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_RILEVATI',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Spostamenti)    : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_SPOSTAMENTI',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Velocità)       : {
                                                Result = this.GetTraduzioneLabel('Generic','TKN_VELOCITA',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Accelerazione)  : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ACCELERAZIONE',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.Assorbimento)   : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_ASSORB',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.TensAlim)       : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_TENSIONE_ALIM',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.MontaggioGV)    : {
                                                Result = this.GetTraduzioneLabel('VUEAppContentGraficiVerticali','TKN_APP_CON_GRAF_MONTAGGIO_GV',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.EvAccAmpiezza)  : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_AMPIEZZA_XYZ',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.EvAccFrequenza) : {
                                                Result = this.GetTraduzioneLabel('VUEGestionale','TKN_PAGE_FREQ_MODULO',this.LinguaUtente)
                                                break
                                              }
          case (this.Moduli.ProfiloLong)    : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_PROFILO_LONG',this.LinguaUtente)            
                                                break
                                              }
          case (this.Moduli.DeformazioneO)  : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_DEFORMAZIONE_O',this.LinguaUtente)            
                                                break
                                              }
          case (this.Moduli.ProfiloLongAll) : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_PROFILO_LONG_ALL',this.LinguaUtente)            
                                                break
                                              }
          case (this.Moduli.DeformazioneOAll): {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_DEFORMAZIONE_O_ALL',this.LinguaUtente)            
                                                break
                                              }
          case (this.Moduli.TemperaturaO)   : {
                                                Result = this.GetTraduzioneLabel('VUEPopupModificaGraficoBanda','TKN_POPUP_BAND_TEMPERATURA_O',this.LinguaUtente)            
                                                break
                                              }
        }
        return Result
    },

    OnClickChiudiPopupModificaGrafico()
    {
      if(this.IsNuovoElemento)
      {
        this.JSONCurrentBanda.MODULO_GRAFICO.splice(this.IndexGraficoAperto, 1)
        this.IsNuovoElemento      = false
      }
      this.PopupModificaGrafico = false
    },

    OnClickConfermaPopupModificaGrafico(JSONGrafici)
    {
      this.JSONCurrentBanda.MODULO_GRAFICO[this.IndexGraficoAperto] = JSONGrafici
      this.PopupModificaGrafico = false
      this.IsNuovoElemento      = false
    },

    OnClickEliminaCurrentGrafico(Indice)
    {
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(Indice, 1)
    },

    OnClickSpostaInAlto(Indice)
    {
      let BandaTmp = this.JSONCurrentBanda.MODULO_GRAFICO[Indice]
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(Indice, 1)
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(Indice - 1, 0, BandaTmp)
    },

    OnClickSpostaInBasso(Indice)
    {
      let BandaTmp = this.JSONCurrentBanda.MODULO_GRAFICO[Indice]
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(Indice, 1)
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(Indice + 1, 0, BandaTmp)
    },

    OnClickApriGrafico(Elemento, Indice)
    {
      this.GraficoSelezionato   = Elemento
      this.IndexGraficoAperto   = Indice
      this.PopupModificaGrafico = true
    },

    CancellaElementoDaBanda(index)
    {
      this.JSONCurrentBanda.MODULO_GRAFICO.splice(index, 1)
    },

    ApriPopupColorPicker()
    {
      this.ColoreInModifica.Colore = this.ColoreBanda
      this.ColoreInModifica.ModuloInModifica = this.ColoreBanda
      this.PopupColorPicker = true
    },

    ConfermaColore()
    {
      this.ColoreBanda = this.ColoreInModifica.Colore
      this.AnnullaColore()
    },

    AnnullaColore()
    {
      this.ColoreInModifica = {}
      this.PopupColorPicker = false
    },

    CanRecord()
    {
      return this.AltezzaBanda !== '' && this.AltezzaBanda !== 0 && this.NomeBanda !== ''
    },
  },

  watch:
  {
    AltezzaBanda:
    {
      handler(NewValue)
      {
        if(NewValue != '')
        {
          if (isNaN(NewValue) || NewValue < 0) 
          {
            this.JSONCurrentBanda.ALTEZZA_BANDA = 0;
            this.AltezzaBanda = 0
          }
          else this.JSONCurrentBanda.ALTEZZA_BANDA = Number(NewValue);
        }
      }
    },

    ColoreBanda:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentBanda.COLORE_BANDA = NewValue
      }
    },

    NomeBanda:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentBanda.NOME_BANDA = NewValue
      }
    },

    BandaNascosta:
    {
      handler(NewValue)
      {
        if(NewValue !== '')
          this.JSONCurrentBanda.NASCOSTO = NewValue
      }
    }
  },

  beforeMount()
  {
    this.JSONCurrentBanda  = JSON.parse(JSON.stringify(this.ObjBanda))
    this.AltezzaBanda      = this.ObjBanda.ALTEZZA_BANDA
    this.ColoreBanda       = this.ObjBanda.COLORE_BANDA
    this.NomeBanda         = this.ObjBanda.NOME_BANDA
    this.BandaNascosta     = this.ObjBanda.NASCOSTO
  }
  
}
</script>